import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Select } from '@bringg/react-components';
import { UnassignButtonTypes } from '../user-assigner-footer/user-assigner-footer';
import './unassign-button.scss';

export interface UnassignButtonProps {
	onUnassignTasks: (detachTasksFromRun: boolean) => void;
	unassignButtonType: UnassignButtonTypes;
	disabled?: boolean;
}

const SHOULD_UNASSIGN_TASK_FROM_RUN = 1;
const SHOULD_NOT_UNASSIGN_TASK_FROM_RUN = 0;
const UnassignButton: React.FC<UnassignButtonProps> = ({
	onUnassignTasks,
	unassignButtonType,
	disabled
}: UnassignButtonProps) => {
	const { t } = useTranslation();
	const [unassignTaskFromRun, setUnassignTaskFromRun] = useState(SHOULD_UNASSIGN_TASK_FROM_RUN);

	const buttonConfig: { [key in UnassignButtonTypes]: { onClick: () => void; text: string } } = {
		orders: {
			onClick: () => onUnassignTasks(true),
			text: t('RUN_USER_ASSIGNMENT.UNASSIGN_RUN')
		},
		driverAndOrders: {
			onClick: () => onUnassignTasks(true),
			text: t('RUN_USER_ASSIGNMENT.UNASSIGN_RUN_ORDERS')
		},
		driverOrDriverAndOrders: {
			onClick: () => onUnassignTasks(!!unassignTaskFromRun),
			text: t('RUN_USER_ASSIGNMENT.UNASSIGN')
		}
	};

	const unassignElementOptions = [
		{ id: SHOULD_UNASSIGN_TASK_FROM_RUN, name: t('RUN_USER_ASSIGNMENT.UNASSIGN_RUN_ORDERS') },
		{ id: SHOULD_NOT_UNASSIGN_TASK_FROM_RUN, name: t('RUN_USER_ASSIGNMENT.UNASSIGN_DRIVER') }
	];

	return (
		<div className="unassign-button">
			{unassignButtonType === 'driverOrDriverAndOrders' && (
				<Select
					dropdownStyle={{ zIndex: 1060 }}
					data-test-id="select-unassign"
					onSelect={value => setUnassignTaskFromRun(value)}
					value={unassignTaskFromRun}
					options={unassignElementOptions}
				/>
			)}

			<Button
				data-test-id="unassign-run"
				className="unassign-run"
				type="primary"
				onClick={buttonConfig[unassignButtonType].onClick}
				disabled={disabled}
			>
				{buttonConfig[unassignButtonType].text}
			</Button>
		</div>
	);
};

export default UnassignButton;
